import {$, _moment} from "../../Application";
import {Page} from "../../Page";

export class CreateTrip extends Page {
    private $short_name;
    private $name;
    private $description;
    private $regions;
    private $topics;

    init() {
        this.$short_name = $('#short_description');
        this.$name = $('#name');
        this.$description = $('#description');
        this.$regions = $('#regions');
        this.$topics = $('#topics');
    }

    runOnCurrentPage(): boolean {
        return $('#createTripForm').length > 0 || $('#editTripForm').length > 0;
    }

    onReady(): void {
        setTimeout(() => {
            this.setIfNameIsManually();
            this.updateTripName();
        }, 1500);
    }

    registerEventHandlers(): void {
        $('#begin, #end').on('focusout', CreateTrip.calculateTripDays);

        // set the same currency within one row
        $('.currency-select').on('change', function () {
            if (!$(this).data('disable-change-handling')) {
                const $selects = $(this).closest('.row').find('.currency-select');
                $selects.data('disable-change-handling', true);
                const value = '' + $(this).val();
                $selects.each((i, select) => {
                    const selectValue = '' + $(select).val();
                    // ignore the '%' and set the currency (not '%') for each select
                    if (selectValue.substring(0, 3) !== value.substring(0, 3)) {
                        $(select).val(value.substring(0, 3)).trigger('change');
                    }
                });
                $selects.data('disable-change-handling', false);
            }
        });
        const priceChangeHandler = function() {
            const name = (<HTMLInputElement>this).name;
            const $currencyInputs = $(this).closest('form').find('[name="' + name + '"]');

            if ($currencyInputs.eq(1).val() !== 'EUR' && $currencyInputs.eq(3).val() !== 'EUR') {
                return;
            }

            const euroIndex = $currencyInputs.eq(1).val() === 'EUR' ? 0 : 2;
            const $euroInput = $currencyInputs.eq(euroIndex);
            const $otherInput = $currencyInputs.eq((euroIndex + 2) % 4);
            const $otherCurrency = $currencyInputs.eq((euroIndex + 2) % 4 + 1);

            const conversionRate = +$otherCurrency.find('option:selected').data('conversion-rate');
            if (!conversionRate) {
                return;
            }

            const otherVal = $otherInput.val();
            if (!otherVal) {
                return;
            }

            if ((otherVal == 0 || otherVal == 1) && $euroInput.val() != otherVal) {
                $euroInput.val(otherVal).trigger('amount-changed');
                return;
            }

            const newVal = Math.round(+otherVal / conversionRate);
            if (newVal != $euroInput.val()) {
                $euroInput.val(newVal);
                $euroInput.trigger('amount-changed');
            }
        };
        $('.currency-select').on('change', priceChangeHandler);
        $('.price-input').on('input', priceChangeHandler);
        const priceHintHandler = function() {
            const val = $(this).val();
            const $helpBlock = $(this).parent().find('.help-block');
            $helpBlock.toggleClass('d-none', val !== '0' && val !== '1');
            $helpBlock.find('.not-available').toggleClass('d-none', val !== '0');
            $helpBlock.find('.on-request').toggleClass('d-none', val !== '1');
        };
        $('.price-input').on('input amount-changed', priceHintHandler);
        $('.price-input').each((i, e) => priceHintHandler.call($(e)));
        this.$short_name.on('input', this.setIfNameIsManually.bind(this));
        this.$short_name.on('focusout', () => {
            if (this.$short_name.val().trim() === '') {
                this.updateTripName();
            }
        });
        this.$regions
            .add(this.$name)
            .add(this.$topics)
            .add(this.$description)
            .on('input change dp.change', this.updateTripName.bind(this));
    }

    private static calculateTripDays(event) {
        const beginVal = $('#begin').val();
        const endVal = $('#end').val();

        if (!beginVal || !endVal) return;

        const begin = _moment(beginVal, 'DD.MM.YYYY');
        const end = _moment(endVal, 'DD.MM.YYYY');

        $('#travel_duration_days').val(end.diff(begin, 'days') + 1);
    }

    setIfNameIsManually() {
        const name = this.$short_name.val().trim();
        this.$short_name.data('manually', !!name && name !== this.createTripName());
        // console.log('manually', this.$short_name.data('manually'));
    }

    updateTripName() {
        if (!this.$short_name.data('manually')) {
            this.$short_name.val(this.createTripName());
        }
    }

    private createTripName(): string {
        const parts = [
            this.createArcticPart(),
            this.createNamePart(),
            // this.createTopicsPart(),
            // this.createDescriptionPart(),
        ];

        return parts.filter(s => s !== '').join(' | ');
    }

    private createArcticPart(): string {
        // return this.$arcticRegions.val();

        // const regions = Array.from(this.$regions.find('option:selected').map((i, e) => $(e).text())).join(', ');
        return this.$regions.find('option:selected').first().data('zone');

        // if (regions) {
        //     return zone + ': ' + regions;
        // }
        //
        // return '';
    }

    private createNamePart(): string {
        return this.$name.val().trim();
    }

    private createTopicsPart(): string {
        return Array.from(this.$topics.find('option:selected').map((i, e) => $(e).text())).join(', ');
    }

    private createDescriptionPart(): string {
        return this.$description.val().trim().replace("\n", "; ");
    }
}
